import { CopyIcon } from "lucide-react";

import { describeThreadCount } from "~/projectCheckoutOptions";

export function ProjectGroupCheckoutPathRow(props: {
  readonly workspaceRoot: string;
  readonly threadCount: number;
}) {
  return (
    <div className="px-3 py-2 sm:px-4">
      <div className="flex min-w-0 items-center rounded-lg bg-muted/30 p-1 text-base text-muted-foreground sm:text-sm">
        <button
          aria-label="Copy checkout path"
          className="group flex min-w-0 flex-1 cursor-pointer items-center gap-2 rounded-md px-2 py-1 text-left outline-none hover:bg-accent/60 hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring"
          type="button"
          onClick={() => void navigator.clipboard?.writeText(props.workspaceRoot)}
        >
          <code className="min-w-0 flex-1 truncate font-mono">{props.workspaceRoot}</code>
          <CopyIcon className="size-4 shrink-0 opacity-60 group-hover:opacity-100" />
        </button>
        <div className="shrink-0 border-l border-border/60 px-2 tabular-nums">
          {describeThreadCount(props.threadCount)}
        </div>
      </div>
    </div>
  );
}
